// extracted by mini-css-extract-plugin
export default {"centeringContainer":"_1XmAx","separator":"_1yshr","container":"_3GgsV"};